import { IExecutionLog } from "@/interfaces/execution-log.interfaces";
import { ExecutionLogMessages } from "@/messages/campaigns/exception-log.messages";
import { ExecutionLogFiltersMessages } from "@/messages/campaigns/execution-log-filters.messages";
import { ExecutionLogStatus } from "@/types/execution-log.types";
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";

import { ExecutionLogFilterKey } from "./types";

export const EXECUTION_LOGS_TABLE_COLUMNS = (messages: ExecutionLogMessages) => {
  return [messages.logDateSent, messages.logContact, messages.logStatus, messages.logError];
};

export const getInitialFilterValues = (campaignId: number): IFilter<IExecutionLog>[] => [
  {
    property: "campaignId",
    value: campaignId,
    filterType: FilterType.Equals,
  },
  {
    property: "all",
    value: "",
    filterType: FilterType.Contains,
  },
];

export const FILTER_OPTIONS = (
  messages: ExecutionLogFiltersMessages
): SelectData<ExecutionLogFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.logContactOption, value: "contact" },
  { label: messages.statusOption, value: "status" },
  { label: messages.logDateOption, value: "dateSent" },
];

export const FILTER_ATTRIBUTES: Partial<Record<ExecutionLogFilterKey, FilterAttributes>> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  contact: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  status: {
    defaultValue: ExecutionLogStatus.Sent,
    type: FilterType.Equals,
    valueType: "options",
  },
  dateSent: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "date",
  },
};

export const STATUS = (messages: ExecutionLogFiltersMessages): SelectData<ExecutionLogStatus>[] => {
  return [
    { value: ExecutionLogStatus.Sent, label: messages.sentOption },
    { value: ExecutionLogStatus.Failed, label: messages.failedOption },
  ];
};

export const FILTER_OPTION_VALUES = (
  messages: ExecutionLogFiltersMessages
): Partial<Record<ExecutionLogFilterKey, SelectData<FilterValue>[]>> => ({
  status: STATUS(messages),
});
